export default Object.freeze({
  Company: 2,
  Individual: 3,
  EducationalEntity: 4,
  DirectPaymentInstitutions: 8,
});
